<template>
  <div class="groupAuthorize_wrap">
    <div class="groupAuthorize_left">
      <div class="searchForm">
        <el-form :model="constData.groupSearchForm" :inline="true">
          <el-form-item label="权限组名称">
            <el-input
              v-model="constData.groupSearchForm.thirdRightGroupName"
              clearable
              placeholder="请输入权限组名称"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div style="display: flex">
          <el-button
            class="query-btn"
            type="primary"
            @click="handleSearchChange(constData.groupSearchForm, 'group')"
            >查询</el-button
          >
          <el-button type="info" @click="handleSearchReset('group')"
            >重置</el-button
          >
        </div>
      </div>
      <ioc-table
        style="height: calc(100% - 50px)"
        ref="refGroupTable"
        :data="groupTableData"
        :option="constData.groupTable"
        :page="constData.groupPage"
        @row-click="handleRowClick"
        @size-change="
          (val) => {
            handleSizeChange(val, 'group');
          }
        "
        @current-change="
          (val) => {
            handleCurrentChange(val, 'group');
          }
        "
      >
        <template slot="menuLeft">
          <div>
            <el-button
              type="primary"
              :loading="tableLoading"
              icon="el-icon-refresh"
              @click="handleSyncGroup()"
              >{{ tableLoading ? "同步中..." : "同步权限组" }}</el-button
            >
          <el-button type="primary"
                     size="small"
                     :loading="tablePersonLoading"
                      icon="el-icon-refresh"
                     @click="syncAuthorization()">{{ tablePersonLoading ? "同步中..." : "同步授权信息" }}</el-button>
                    </div>
        </template>
      </ioc-table>
    </div>
    <div class="groupAuthorize_right">
      <ioc-table
        ref="refPeoPleTable"
        :data="peopleTableData"
        :option="constData.peopleTable"
        :page="constData.peoplePage"
        @selection-change="handleSelectionChange"
        @search-change="
          (val) => {
            handleSearchChange(val, 'people');
          }
        "
        @search-reset="
          (val) => {
            handleSearchReset('people');
          }
        "
        @size-change="
          (val) => {
            handleSizeChange(val, 'people');
          }
        "
        @current-change="
          (val) => {
            handleCurrentChange(val, 'people');
          }
        "
      >
        <template slot="menuLeft">
          <div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="handleAddPeople"
            >
              新增
            </el-button>
            <el-button
              type="info"
              icon="el-icon-delete"
              @click="handleDelPeople()"
              :disabled="!checkDelPeople.length ? true : false"
            >
              批量移除
            </el-button>
          </div>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-tooltip
            class="item m5"
            effect="dark"
            content="移除"
            placement="top-start"
          >
            <el-button
              type="text"
              class="el-icon-delete"
              @click="handleDelPeople(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </ioc-table>
    </div>
    <peopleVue
      :groupCode="checkGroup.thirdRightGroupCode"
      :showPeoplePanel="showPeoplePanel"
      @handleClosePeoplePanel="handleClosePeoplePanel"
    />
  </div>
</template>

<script>
import { api } from "../api/index";
import utils from "@src/common/utils";
import peopleVue from "../components/people.vue";
import { groupTable } from "../config/groupTable";
import { peopleTable } from "../config/peopleTable";
export default {
  components: {
    peopleVue,
  },
  data() {
    return {
      constData: {
        groupPage: {
          pageNum: 1,
          total: 0,
          pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        },
        peoplePage: {
          pageNum: 1,
          total: 0,
          pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        },
        peopleTable: peopleTable(false, true),
        groupTable: groupTable(),
        groupSearchForm: {},
        peopleSearchForm: {},
      },
      subLoading: false,
      tableLoading: false,
      tablePersonLoading: false,
      showPeoplePanel: false,
      groupTableData: [],
      peopleTableData: [],
      checkGroup: {
        thirdRightGroupCode: "",
      },
      checkDelPeople: [],
    };
  },
  created() {},
  mounted() {
    this.groupGetList();
  },
  methods: {
    // 同步权限组
    handleSyncGroup() {
      this.$confirm("您确定手动刷新重新同步全部权限组吗?", "同步确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.syncAuthorityGroup).then((response) => {
          this.tableLoading = true;
          if (response && response.success) {
            this.tableLoading = false;
            this.$message({
              message: "同步成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.tableLoading = false;
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.groupGetList();
        });
      });
    },
    // 同步人员权限
    syncAuthorization() {
      this.$confirm("您确定手动刷新重新同步全部人员权限吗?", "同步确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.person.syncAuthorityList).then((response) => {
          this.tablePersonLoading = true;
          if (response && response.success) {
            this.tablePersonLoading = false;
            this.$message({
              message: "同步成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.tablePersonLoading = false;
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.groupGetList();
        });
      });
    },
    // 点击权限组查询该组下人员
    handleRowClick(row) {
      this.checkGroup = { ...row };
      this.peopleGetList();
    },
    // 条件搜索
    handleSearchChange(param, type) {
      console.log(param);
      this.constData[`${type}Page`].pageNum = 1;
      this.constData[`${type}SearchForm`] = Object.assign({}, param);
      this[`${type}GetList`]();
    },
    // 条件重置
    handleSearchReset(type) {
      this.constData[`${type}Page`].pageNum = 1;
      this.constData[`${type}Page`].pageSize = 10;
      this.constData[`${type}SearchForm`] = {};
      this[`${type}GetList`]();
    },
    // 分页查询
    handleCurrentChange(val, type) {
      this.constData[`${type}Page`].pageNum = val;
      this[`${type}GetList`]();
    },
    // 条数查询
    handleSizeChange(val, type) {
      this.constData[`${type}Page`].pageNum = 1;
      this.constData[`${type}Page`].pageSize = val;
      this[`${type}GetList`]();
    },
    // 批量多选
    handleSelectionChange(row) {
      this.checkDelPeople = [...row];
    },
    // 人员弹窗
    handleAddPeople() {
      this.showPeoplePanel = true;
    },
    handleDelPeople(row) {
      this.$confirm("您确定将人员从所属权限组移除吗?", "移除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {};
        if (!row) {
          // 批量移除
          params.authCodeList = this.checkDelPeople.map((el) => {
            return el.authCode;
          });
        } else {
          params.authCodeList = [row.authCode];
        }
        this.$fetch(api.person.deleteAuthority, params).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "移除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.peopleGetList();
        });
      });
    },
    // 取消选择
    handleClosePeoplePanel(type) {
      if (type == true) {
        this.peopleGetList();
      }

      this.showPeoplePanel = false;
    },
    //权限组查询
    groupGetList() {
      let params = {
        ...this.constData.groupPage,
        ...this.constData.groupSearchForm,
        rightGroupType: 1,
      };
      this.$fetch(api.getGroup, params).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        this.groupTableData = res.returnObj.list.map((el) => {
          return el;
        });
        this.constData.groupPage.total = res.returnObj.total;
        let row = { ...this.groupTableData[0] };
        this.$refs.refGroupTable.$refs.multipleTable.setCurrentRow(row);
        this.handleRowClick(row);
      });
    },
    // 权限组下人员查询
    peopleGetList() {
      let params = {
        ...this.constData.peoplePage,
        ...this.constData.peopleSearchForm,
        thirdRightGroupCodeList: [this.checkGroup.thirdRightGroupCode],
        personnelType: 1,
      };
      this.$fetch(api.getAuthorityList, params).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        this.peopleTableData = res.returnObj.list.map((el) => {
          return el;
        });
        this.constData.peoplePage.total = res.returnObj.total;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.groupAuthorize {
  &_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }
  &_left {
    width: 600px;
    height: 100%;
  }
  &_right {
    width: calc(100% - 616px);
    height: 100%;
  }
}
</style>